
import Templates from "../../Templates/Templates";

const TemplatesPage = () => {
  return <Templates />;
};

export default TemplatesPage;
